/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useKeycloakUsers
 */

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

interface IModel {
	apiParams?: UserManagement.IApiParams;
	allUsers?: boolean;
	pageNumber?: number;
	pageSize?: number;
}

/**
 * useKeycloakUsers hook
 * @returns {UseQueryResult} useKeycloakUsers
 */
const useKeycloakUsers = (
	{ apiParams = {}, pageNumber, pageSize, allUsers = true }: IModel,
	options?: IQueryOptions,
): UseQueryResult<UserManagement.IModel, unknown> => {
	return useQuery({
		queryKey: [QUERY_KEYS.keycloakUsers, { apiParams, allUsers, pageNumber, pageSize }],
		queryFn: async () => {
			const { data } = await api.KeycloakUserApi.getUsers({
				userSearchModel: apiParams,
				allUsers,
				pgNum: pageNumber,
				pgSize: pageSize,
			});
			return data;
		},
		...options,
	});
};

export default useKeycloakUsers;
